module.exports = __webpack_public_path__ + "static/aerial-views-xv-5e22e42e87a9d0a392cd11416681d570.jpg";